export default data => {
    return {
        type: 'SET_TOAST_MESSAGE_STATE',
        data
    };
};
